<template>
  <div class="dropdown-select dropdown-select-hover">
    <language-icon />
    <div class="dropdown-select-content">
      <a v-for="language in languages" :key="language" @click="changeLanguage(language.name)">{{language.label}}</a>
    </div>
  </div>
</template>

<script>
import LanguageIcon from "./icons/languageIcon";
export default {
  name: "languageWithIcon",
  components: {LanguageIcon},
  data: () => ({
    languages: [{
      label: "English",
      name: "en"
    }, {
      label: "Русский",
      name: "ru"
    }]
  }),
  methods:{
    changeLanguage(language){
      this.$i18n.locale = language;
      window.localStorage.setItem("LOCALE-i18n", language);
    },
  },
  created() {
    let locale = window.localStorage.getItem("LOCALE-i18n");

    if (!locale) {
      locale = "en";
      window.localStorage.setItem("LOCALE-i18n", locale);
    }
    this.$i18n.locale = locale;
  }
}
</script>